<template>
    <v-list>
        <v-list-item
            v-for="widget in widgetList"
            :key="`widget-${widget.id}`"
            class="mb-5"
        >
            <Widget
                v-if="!isWidgetDisabled(widget) && (!('hotspots' in widget) || ('hotspots' in widget && getFilteredHotspot(widget.hotspots).length === 0))"
                :widget="widget"
                @go-to-widget="goToWidget"
            />

            <WidgetWithHotspot
                v-else-if="!isWidgetDisabled(widget) && getFilteredHotspot(widget.hotspots).length > 0"
                :widget="widget"
                @go-to-widget="goToWidget"
                @go-to-hotspot="gotoHotspot"
            />

            <DisabledOfflineWidget
                v-else
                :widget="widget"
            />
        </v-list-item>
    </v-list>
</template>

<script>
    import { mapGetters } from 'vuex';

    import DisabledOfflineWidget from '@/components/sidebar/components/DisabledOfflineWidget';
    import Widget from '@/components/sidebar/components/Widget';
    import WidgetWithHotspot from '@/components/sidebar/components/WidgetWithHotspot';

    export default {
        name: 'WidgetsList',
        components: {
            DisabledOfflineWidget,
            Widget,
            WidgetWithHotspot
        },
        props: {
            widgetList: {
                type: Array,
                required: true
            }
        },
        data: () => ({
            disabledOfflineWidgets: [
                'map-view',
                'district-video',
                'models',
                'documentation'
            ],
            skippedHotspotType: [
                'light-variation'
            ]
        }),
        computed: {
            ...mapGetters([
                'isOfflineMode',
                'isOnline'
            ])
        },
        methods: {
            isWidgetDisabled(widget) {
                return (this.disabledOfflineWidgets.includes(widget.id) || widget.url != null) && !this.isOnline ? true : false;
            },
            goToWidget(widget, subitem) {
                this.$emit('go-to-widget', widget, subitem);
            },
            gotoHotspot(widget, hotspot) {
                this.$emit('go-to-hotspot', widget, hotspot);
            },
            getFilteredHotspot(hotspotList) {
                return hotspotList.filter(hotspot => !this.skippedHotspotType.includes(hotspot.type));
            }
        }
    };
</script>


// WEBPACK FOOTER //
// src/components/sidebar/components/WidgetsList.vue